
import React from 'react'; 
import { Navbar, Nav, Container } from 'react-bootstrap'; 
import { Link, useLocation } from 'react-router-dom'; 
import 'bootstrap/dist/css/bootstrap.min.css'; 
import './Nav.css'; 
import logo from "../images/img123.png"; 
import WhatsAppChatButton from '../../components/Whatsapp'; 
import Chatbot from '../../components/Chatbot'; 
 
 
const closeMenu = () => { 
  const chkElement = document.getElementById('chk1'); 
  if (chkElement) { 
    chkElement.checked = false; 
  } 
}; 
 
function MyNavbar() { 
  const location = useLocation(); 
 
  return ( 
    <div> 
      <Navbar className="navbar-custom-bg" expand="lg" collapseOnSelect> 
        <Container> 
          <Navbar.Brand href="/" className="navbar-title d-flex align-items-center"> 
            <img 
              src={logo} 
              alt="Clasp Tax Logo" 
              className="navbar-logo" 
            /> 
            <div className="brand-text ms-2"> 
              <span className="company-name">Clasp Tax</span> 
              <p className="tagline">Your Numbers. Our Expertise.</p> 
            </div> 
          </Navbar.Brand> 
 
          <Navbar.Toggle aria-controls="basic-navbar-nav" /> 
          <Navbar.Collapse id="basic-navbar-nav"> 
            <Nav className="ms-auto text-center"> 
              <Link  
                to="/"  
                className={`navbar-link ${location.pathname === '/' ? 'active' : ''}`} 
                onClick={closeMenu} 
              > 
                HOME 
              </Link> 
              <Link  
                to="/aboutus"  
                className={`navbar-link ${location.pathname === '/aboutus' ? 'active' : ''}`} 
                onClick={closeMenu} 
              > 
                ABOUT US 
              </Link> 
 
              <div className="dropdown"> 
                <span 
                  id="dropdownMenuButton" 
                  className="navbar-link" 
                > 
                  SERVICES 
                </span> 
                <div className="dropdown-menu" aria-labelledby="dropdownMenuButton"> 
                  <Link to="/Se" className="dropdown-item" onClick={closeMenu}> 
                    Individual Services 
                  </Link> 
                  <hr /> 
                  <Link to="/Se1" className="dropdown-item" onClick={closeMenu}> 
                    Business Services 
                  </Link> 
                </div> 
              </div> 
 
<Link  
                to="/outsourcing"  
                className={`navbar-link ${location.pathname === '/outsourcing' ? 'active' : ''}`} 
                onClick={closeMenu} 
              > 
                OUTSOURCING
              </Link> 


              <Link  
                to="/price"  
                className={`navbar-link ${location.pathname === '/price' ? 'active' : ''}`} 
                onClick={closeMenu} 
              > 
                PRICE 
              </Link> 
              <Link  
                to="/refundstatus"  
                className={`navbar-link ${location.pathname === '/refundstatus' ? 'active' : ''}`} 
                onClick={closeMenu} 
              > 
                REFUND STATUS 
              </Link> 
 
              <Link  
                to="/careers"  
                className={`navbar-link ${location.pathname === '/careers' ? 'active' : ''}`} 
                onClick={closeMenu} 
              > 
                CAREERS 
              </Link> 
 
 
 
              <Link  
                to="/contactusform"  
                className={`navbar-link ${location.pathname === '/contactusform' ? 'active' : ''}`} 
                onClick={closeMenu} 
              > 
                CONTACT US 
              </Link> 
            </Nav> 
          </Navbar.Collapse> 
        </Container> 
      </Navbar> 
    
 
    </div> 
  ); 
} 
 
export default MyNavbar;